
export enum ChatEntryStatus
{
	Unsent = "unsent",
	Sending = "sending",
	Sent = "sent",
	Error = "error"
}
